export default __webpack_public_path__ + "static/logo-f9d5b37a36b810d5512edbb393a4a20c.png";